import React, { useState } from 'react';
import {
  PRIMARY,
  TEXT_MUTED,
  BORDER_LIGHT,
  TEXT_DARK,
  FONT_HEADING,
} from '../designTokens';
import { RuleManagementSection } from './RuleManagementSection';
import { RunSection } from './RunSection';
import { RunHistoryTable } from './RunHistoryTable';
import { FamilyGroupsSection } from './FamilyGroupsSection';
import { TableReservationsSection } from './TableReservationsSection';

type Section = 'rules' | 'new-run' | 'history' | 'family-groups' | 'reservations';

const SECTIONS: { key: Section; label: string }[] = [
  { key: 'rules', label: 'Rules' },
  { key: 'new-run', label: 'New Run' },
  { key: 'history', label: 'History' },
  { key: 'family-groups', label: 'Family Groups' },
  { key: 'reservations', label: 'Reservations' },
];

const styles: Record<string, React.CSSProperties> = {
  container: {
    maxWidth: '900px',
  },
  header: {
    marginBottom: '1rem',
  },
  title: {
    fontSize: '1.1rem',
    fontFamily: FONT_HEADING,
    fontWeight: 700,
    color: TEXT_DARK,
    margin: 0,
  },
  subNav: {
    display: 'flex',
    gap: '0',
    marginBottom: '1.25rem',
    borderBottom: `1px solid ${BORDER_LIGHT}`,
  },
  tab: {
    padding: '0.5rem 1rem',
    fontSize: '0.82rem',
    fontWeight: 500,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    color: TEXT_MUTED,
    borderBottom: '2px solid transparent',
    marginBottom: '-1px',
    transition: 'color 0.2s, border-color 0.2s',
  },
  tabActive: {
    padding: '0.5rem 1rem',
    fontSize: '0.82rem',
    fontWeight: 600,
    cursor: 'pointer',
    border: 'none',
    backgroundColor: 'transparent',
    color: PRIMARY,
    borderBottom: `2px solid ${PRIMARY}`,
    marginBottom: '-1px',
    transition: 'color 0.2s, border-color 0.2s',
  },
};

export function BatchAssignmentPanel() {
  const [activeSection, setActiveSection] = useState<Section>('rules');

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Batch Assignment</h2>
      </div>

      <nav style={styles.subNav} aria-label="Batch assignment sections">
        {SECTIONS.map((section) => (
          <button
            key={section.key}
            style={activeSection === section.key ? styles.tabActive : styles.tab}
            onClick={() => setActiveSection(section.key)}
            aria-current={activeSection === section.key ? 'page' : undefined}
          >
            {section.label}
          </button>
        ))}
      </nav>

      {activeSection === 'rules' && <RuleManagementSection />}
      {activeSection === 'new-run' && <RunSection />}
      {activeSection === 'history' && <RunHistoryTable />}
      {activeSection === 'family-groups' && <FamilyGroupsSection />}
      {activeSection === 'reservations' && <TableReservationsSection />}
    </div>
  );
}
